import { Component, Input, EventEmitter, Output, ViewChild, ElementRef } from "@angular/core";

@Component({
  selector: 'my-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent {
  @ViewChild('fileSelector', {static: false}) private fileSelectorElement: ElementRef;
  
  @Input() fileTypeFilter: string = '*.*';

  @Output('onFileSelected') fileSelected = new EventEmitter<File>();

  constructor() { }

  public resetFileSelection() {
    // TP139777: Reset file input element's value
    this.fileSelectorElement.nativeElement.value = "";
  }

  onAfterFileSelected(e: Event) {
    let files: FileList = (e.target as HTMLInputElement).files;
    let file: File;

    if (files.length > 0) {
      file = files.item(0);
    }
    else {
      file = undefined;
    }
    this.fileSelected.emit(file);
  }
}